var _rect, _path, _path2, _rect2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyCourse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.174316,
    width: 48,
    height: 49.2779,
    rx: 16,
    fill: "#16151B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.088 15.6872C24.3317 15.5876 24.605 15.5882 24.8484 15.6888L36.9218 20.6812C37.7438 21.0211 37.7462 22.1846 36.9256 22.5279L24.7234 27.6325C24.4805 27.7341 24.2073 27.7358 23.9632 27.6373L11.5987 22.6456C10.7665 22.3096 10.764 21.1322 11.5948 20.7927L24.088 15.6872Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4342 26.057L24.1741 29.1891L31.9139 26.057C32.2426 25.924 32.6015 26.1659 32.6015 26.5205V30.2426C32.4891 31.3101 30.6464 33.4451 24.1741 33.4451C17.7018 33.4451 15.859 31.3101 15.7466 30.2426V26.5205C15.7466 26.1659 16.1055 25.924 16.4342 26.057Z",
    fill: "#6C6D76"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1636,
    y: 21.7241,
    width: 0.880127,
    height: 8.8833,
    rx: 0.440063,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.6037,
    cy: 26.8096,
    r: 1.5,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCourse);
export default __webpack_public_path__ + "static/media/my_course.58465c4d.svg";
export { ForwardRef as ReactComponent };